export const bookingPortalUrl = 'https://customer.laasone.com/';
export const demoBookingUrl = 'https://calendly.com/laasone/30min';
